module.exports = __webpack_public_path__ + "img/vyl-banner.8c10662b.jpg";